// Содержание таблиц для 5 класса (по фотографиям буклета Музыка зарубежных стран»).

const TABLE_CONTENT_5_DISK1 = [
    {
        num: 1,
        authorTitle: 'Григорианские хоралы',
        performer: 'Ансамбль «Schola cantorum»',
        tracks: [
            { trackNum: 2, duration: '0:38' },
            { trackNum: 4, duration: '0:49' },
            { trackNum: 6, duration: '1:22' },
        ],
    },
    {
        num: 2,
        authorTitle: 'Органум',
        performer: 'Ансамбль «Sequentia»',
        tracks: [{ trackNum: 8, duration: '1:22' }],
    },
    {
        num: 3,
        authorTitle: 'Раннее многоголосие',
        performer: 'Ансамбль «De Roma»',
        tracks: [{ trackNum: 10, duration: '0:59' }],
    },
    {
        num: 4,
        authorTitle: 'Органум Перотина',
        performer: 'Ансамбль «Deller Consort»',
        tracks: [{ trackNum: 12, duration: '1:13' }],
    },
    {
        num: 5,
        authorTitle: 'В. фон дер Фогельвейде. Рыцарская песня',
        performer: 'Оркестр «Studio der Truhen Musik» солист М. ван Эгмонд',
        tracks: [{ trackNum: 14, duration: '1:13' }],
    },
    {
        num: 6,
        authorTitle: 'К. Жанекен. Пение птиц',
        performer: 'Полифонический ансамбль Парижа. Дир. Ш. Равье',
        tracks: [{ trackNum: 16, duration: '1:51' }],
    },
    {
        num: 7,
        authorTitle: 'Дж. Палестрина. Месса Папы Марчелло. Agnus Dei',
        performer: 'Чешский филармонический хор. Дир. Й. Веселка',
        tracks: [{ trackNum: 18, duration: '1:54' }],
    },
    {
        num: 8,
        authorTitle: 'Я. Пери. Фрагмент оперы «Эвридика»',
        performer: 'Ансамбль «Мадригал»',
        tracks: [{ trackNum: 20, duration: '1:34' }],
    },
    {
        num: 9,
        authorTitle: 'К. Монтеверди. Опера «Орфей». 5 акт. Дуэт Орфея и Аполлона',
        performer: 'Оркестр английских солистов барокко. Дир. Дж. Гардинер. Орфей – Э. Джонсон, Аполлон – Н. Робертсон',
        tracks: [{ trackNum: 22, duration: '1:13' }],
    },
    {
        num: 10,
        authorTitle: 'Ж. Б. Люлли. Опера «Изида». Пролог',
        performer: 'Хор и оркестр Парижской оперы. Дир. Ж. Пайяр',
        tracks: [{ trackNum: 24, duration: '1:41' }],
    },
    {
        num: 11,
        authorTitle: 'Г. Перселл. Опера «Дидона и Эней». 3 действие Ария Дидоны',
        performer: 'Английский камерный оркестр. Дир. Р. Леппард. Дидона – Дж. Норман',
        tracks: [{ trackNum: 26, duration: '4:13' }],
    },
    {
        num: 12,
        authorTitle: 'И. С. Бах. Страсти по Матфею. Ария альта № 47',
        performer: 'Оркестр «La Petite Bande». Дир. Г. Ленхардт. Р. Жакоб (альт)',
        tracks: [{ trackNum: 28, duration: '2:41' }],
    },
    {
        num: 13,
        authorTitle: 'А. Вивальди. Концерт D-dur. Часть 1',
        performer: 'Оркестр New Irish Chamber Orchestra',
        tracks: [{ trackNum: 30, duration: '1:35' }],
    },
    {
        num: 14,
        authorTitle: 'Д. Букстехуде. Фуга фа диез минор',
        performer: 'О. Янченко (орган)',
        tracks: [{ trackNum: 32, duration: '1:55' }],
    },
    {
        num: 15,
        authorTitle: 'И. Пахельбель. Хоральная прелюдия',
        performer: 'Г. Гродберг (орган)',
        tracks: [{ trackNum: 34, duration: '1:22' }],
    },
    {
        num: 16,
        authorTitle: 'Ф. Куперен. Жнецы',
        performer: 'А. Любимов (клавесин)',
        tracks: [{ trackNum: 36, duration: '1:24' }],
    },
    {
        num: 17,
        authorTitle: 'И. С. Бах. Токката и фуга ре минор:',
        performer: 'О. Винтер (орган)',
        tracks: [
            { trackNum: 38, duration: '1:27' },
            { trackNum: 40, duration: '1:14' },
            { trackNum: 42, duration: '1:06' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Токката', trackNum: 38, duration: '1:27' },
            { type: 'subheading', section: 'Фуга:' },
            { type: 'track', section: 'Экспозиция', trackNum: 40, duration: '1:14', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 42, duration: '1:06', indentLevel: 1 },
        ],
    },
    {
        num: 18,
        authorTitle: 'И. С. Бах. Инвенция До мажор',
        performer: 'Г. Гульд (фортепиано)',
        tracks: [{ trackNum: 44, duration: '0:47' }],
    },
    {
        num: 19,
        authorTitle: 'И. С. Бах. Инвенция Фа мажор',
        performer: 'Г. Гульд (фортепиано)',
        tracks: [{ trackNum: 46, duration: '1:05' }],
    },
    {
        num: 20,
        authorTitle: 'И. С. Бах. Синфония фа минор',
        performer: 'Г. Гульд (фортепиано)',
        tracks: [{ trackNum: 48, duration: '2:19' }],
    },
    {
        num: 21,
        authorTitle: 'И. С. Бах. Французская сюита до минор:',
        performer: 'Х. Дрейфус (клавесин)',
        tracks: [
            { trackNum: 50, duration: '1:36' },
            { trackNum: 52, duration: '2:00' },
            { trackNum: 54, duration: '3:07' },
            { trackNum: 56, duration: '2:37' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Аллеманда', trackNum: 50, duration: '1:36' },
            { type: 'track', section: 'Куранта', trackNum: 52, duration: '2:00' },
            { type: 'track', section: 'Сарабанда', trackNum: 54, duration: '3:07' },
            { type: 'track', section: 'Жига', trackNum: 56, duration: '2:37' },
        ],
    },
    {
        num: 22,
        authorTitle: 'И. С. Бах. Прелюдия и фуга до минор №2. І том Хорошо темперированного клавира:',
        performer: 'С. Рихтер (фортепиано)',
        tracks: [
            { trackNum: 58, duration: '1:19' },
            { trackNum: 60, duration: '1:31' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Прелюдия', trackNum: 58, duration: '1:19' },
            { type: 'track', section: 'Фуга', trackNum: 60, duration: '1:31' },
        ],
    },
    {
        num: 23,
        authorTitle: 'Дж. Перголези. Опера «Служанка-госпожа»:',
        performer: 'Ансамбль «Collegium Anreum» Уберто – З. Нимстерн, Серпина – М. Бонифаччо',
        tracks: [
            { trackNum: 62, duration: '2:12' },
            { trackNum: 64, duration: '2:00' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Ария Уберто №2', trackNum: 62, duration: '2:12' },
            { type: 'track', section: 'Дуэт Уберто и Серпины', trackNum: 64, duration: '2:00' },
        ],
    },
    {
        num: 24,
        authorTitle: 'К. Глюк. Опера «Орфей». 3 действие. Ария Орфея № 43',
        performer: 'Симф. орк. Берлинского радио.',
        tracks: [{ trackNum: 66, duration: '2:12' }],
    },
];

const TABLE_CONTENT_5_DISK2 = [
    {
        num: 25,
        authorTitle: 'Й. Гайдн. Симфония № 103 Ми – бемоль мажор',
        performer: 'Берлинский филарм. орк. Дир. Г. фон Караян',
        tracks: [{ trackNum: 2, duration: '1:12' }, { trackNum: 4, duration: '0:28' }, { trackNum: 6, duration: '0:34' }, { trackNum: 8, duration: '0:35' }, { trackNum: 10, duration: '0:06' }, { trackNum: 12, duration: '0:26' }, { trackNum: 14, duration: '1:54' }, { trackNum: 16, duration: '1:16' }, { trackNum: 18, duration: '1:30' }, { trackNum: 20, duration: '0:46' }, { trackNum: 22, duration: '0:23' }, { trackNum: 24, duration: '0:23' }, { trackNum: 26, duration: '0:22' }, { trackNum: 28, duration: '1:37' }, { trackNum: 30, duration: '1:04' }, { trackNum: 32, duration: '1:05' }, { trackNum: 34, duration: '2:07' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 2, duration: '1:12' },
            { type: 'track', section: 'Вступление', trackNum: 4, duration: '0:28' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 6, duration: '0:34', indentLevel: 2 },
            { type: 'track', section: 'Главная партия', trackNum: 8, duration: '0:35', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 10, duration: '0:06', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 12, duration: '0:26', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 14, duration: '1:54', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 16, duration: '1:16', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 18, duration: '1:30', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'І тема вариаций', trackNum: 20, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'ІІ тема вариаций', trackNum: 22, duration: '0:23', indentLevel: 1 },
            { type: 'track', section: '2-я вариация І темы', trackNum: 24, duration: '0:23', indentLevel: 1 },
            { type: 'track', section: '2-я вариация ІІ темы', trackNum: 26, duration: '0:22', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 28, duration: '1:37', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Основная тема менуэта', trackNum: 30, duration: '1:04', indentLevel: 1 },
            { type: 'track', section: 'Тема трио', trackNum: 32, duration: '1:05', indentLevel: 1 },
            { type: 'subheading', section: 'IV часть:' },
            { type: 'track', section: 'Фрагмент', trackNum: 34, duration: '2:07', indentLevel: 1 },
        ],
    },
    {
        num: 26,
        authorTitle: 'Й. Гайдн. Соната Ре мажор',
        performer: 'А. Стайер (фортепиано)',
        tracks: [{ trackNum: 36, duration: '0:15' }, { trackNum: 38, duration: '0:15' }, { trackNum: 40, duration: '0:33' }, { trackNum: 42, duration: '0:11' }, { trackNum: 44, duration: '1:51' }, { trackNum: 46, duration: '2:33' }, { trackNum: 48, duration: '3:02' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 36, duration: '0:15', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 38, duration: '0:15', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 40, duration: '0:33', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 42, duration: '0:11', indentLevel: 2 },
            { type: 'track', section: 'Разработка и Реприза', trackNum: 44, duration: '1:51', indentLevel: 1 },
            { type: 'track', section: 'ІІ часть', trackNum: 46, duration: '2:33', indentLevel: 1 },
            { type: 'track', section: 'ІІІ часть', trackNum: 48, duration: '3:02', indentLevel: 1 },
        ],
    },
    {
        num: 27,
        authorTitle: 'Й. Гайдн. Соната ми минор',
        performer: 'Дж. Маккейб (фортепиано)',
        tracks: [{ trackNum: 50, duration: '0:14' }, { trackNum: 52, duration: '0:34' }, { trackNum: 54, duration: '0:25' }, { trackNum: 56, duration: '2:09' }, { trackNum: 58, duration: '1:30' }, { trackNum: 60, duration: '3:36' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 50, duration: '0:14', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 52, duration: '0:34', indentLevel: 2 },
            { type: 'track', section: 'Побочная и заключительная партии', trackNum: 54, duration: '0:25', indentLevel: 2 },
            { type: 'track', section: 'Разработка и реприза', trackNum: 56, duration: '2:09', indentLevel: 1 },
            { type: 'track', section: 'ІІ часть', trackNum: 58, duration: '1:30', indentLevel: 1 },
            { type: 'track', section: 'ІІІ часть', trackNum: 60, duration: '3:36', indentLevel: 1 },
        ],
    },
    {
        num: 28,
        authorTitle: 'В. А. Моцарт. Опера «Свадьба Фигаро». Увертюра.',
        performer: 'Баварский хор и симф. орк. Дир. Сэр К. Девис',
        tracks: [{ trackNum: 62, duration: '0:07' }, { trackNum: 64, duration: '0:10' }, { trackNum: 66, duration: '0:15' }, { trackNum: 68, duration: '0:20' }, { trackNum: 70, duration: '0:15' }, { trackNum: 72, duration: '2:28' }, { trackNum: 74, duration: '1:30' }, { trackNum: 76, duration: '1:04' }, { trackNum: 78, duration: '3:50' }, { trackNum: 80, duration: '1:06' }, { trackNum: 82, duration: '2:57' }, { trackNum: 84, duration: '1:16' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Экспозиция:' },
            { type: 'track', section: '1-я тема главной партии', trackNum: 62, duration: '0:07', indentLevel: 1 },
            { type: 'track', section: '2-я тема главной партии', trackNum: 64, duration: '0:10', indentLevel: 1 },
            { type: 'track', section: '1-я тема побочной партии', trackNum: 66, duration: '0:15', indentLevel: 1 },
            { type: 'track', section: '2-я тема побочной партии', trackNum: 68, duration: '0:20', indentLevel: 1 },
            { type: 'track', section: 'Тема заключительной партии', trackNum: 70, duration: '0:15', indentLevel: 1 },
            { type: 'track', section: 'Предыкт, реприза и кода', trackNum: 72, duration: '2:28', indentLevel: 1 },
            { type: 'subheading', section: 'І действие:' },
            { type: 'subheading', section: 'Каватина Фигаро', indentLevel: 1 },
            { type: 'track', section: 'Тема среднего раздела и репризы', trackNum: 74, duration: '1:30', indentLevel: 2 },
            { type: 'track', section: 'Ария Фигаро «Мальчик резвый...»', trackNum: 76, duration: '1:04', indentLevel: 1 },
            { type: 'track', section: 'Ария Керубино «Рассказать, объяснить...»', trackNum: 78, duration: '3:50', indentLevel: 1 },
            { type: 'subheading', section: 'II действие' },
            { type: 'track', section: 'Ария Керубино «Сердце волнует жаркая кровь»', trackNum: 80, duration: '1:06', indentLevel: 1 },
            { type: 'subheading', section: 'IV действие:' },
            { type: 'track', section: 'Ария Сюзанны', trackNum: 82, duration: '2:57', indentLevel: 1 },
            { type: 'track', section: 'Ария Сюзанны', trackNum: 84, duration: '1:16', indentLevel: 1 },
        ],
    },
    {
        num: 29,
        authorTitle: 'В. А. Моцарт. Соната Ля мажор',
        performer: 'М. Пирес (фортепиано)',
        tracks: [{ trackNum: 86, duration: '1:51' }, { trackNum: 88, duration: '0:24' }, { trackNum: 89, duration: '0:33' }, { trackNum: 90, duration: '1:31' }, { trackNum: 91, duration: '0:35' }, { trackNum: 92, duration: '1:13' }, { trackNum: 93, duration: '1:31' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'track', section: 'Тема вариаций', trackNum: 86, duration: '1:51', indentLevel: 1 },
            { type: 'track', section: '1-я вариация', trackNum: 88, duration: '0:24', indentLevel: 1 },
            { type: 'track', section: '2-я вариация', trackNum: 89, duration: '0:33', indentLevel: 1 },
            { type: 'track', section: '3-я вариация', trackNum: 90, duration: '1:31', indentLevel: 1 },
            { type: 'track', section: '4-я вариация', trackNum: 91, duration: '0:35', indentLevel: 1 },
            { type: 'track', section: '5-я вариация', trackNum: 92, duration: '1:13', indentLevel: 1 },
            { type: 'track', section: '6-я вариация', trackNum: 93, duration: '1:31', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_5_DISK3 = [
    {
        num: 29,
        authorTitle: 'В. А. Моцарт. Соната Ля мажор (продолжение)',
        performer: 'М. Пирес (фортепиано)',
        tracks: [{ trackNum: 1, duration: '1:15' }, { trackNum: 2, duration: '2:11' }, { trackNum: 3, duration: '0:41' }, { trackNum: 4, duration: '0:39' }, { trackNum: 5, duration: '1:01' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'Тема первой части менуэта', trackNum: 1, duration: '1:15', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Первая часть', trackNum: 2, duration: '2:11', indentLevel: 1 },
            { type: 'track', section: 'Средняя часть', trackNum: 3, duration: '0:41', indentLevel: 1 },
            { type: 'track', section: 'Припев', trackNum: 4, duration: '0:39', indentLevel: 1 },
            { type: 'track', section: 'Припев и кода', trackNum: 5, duration: '1:01', indentLevel: 1 },
        ],
    },
    {
        num: 30,
        authorTitle: 'В. А. Моцарт. Симфония соль минор, № 40',
        performer: 'Берлинский симф. орк. Дир. Г. фон Караян',
        tracks: [{ trackNum: 6, duration: '1:16' }, { trackNum: 7, duration: '0:42' }, { trackNum: 8, duration: '0:50' }, { trackNum: 9, duration: '0:46' }, { trackNum: 10, duration: '1:38' }, { trackNum: 11, duration: '3:01' }, { trackNum: 12, duration: '1:01' }, { trackNum: 13, duration: '0:17' }, { trackNum: 14, duration: '1:14' }, { trackNum: 15, duration: '1:46' }, { trackNum: 17, duration: '1:37' }, { trackNum: 18, duration: '0:43' }, { trackNum: 19, duration: '0:31' }, { trackNum: 20, duration: '1:36' }, { trackNum: 21, duration: '2:09' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 6, duration: '1:16', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 7, duration: '0:42', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 8, duration: '0:50', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 9, duration: '0:46', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 10, duration: '1:38', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 11, duration: '3:01', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'Главная партия', trackNum: 12, duration: '1:01', indentLevel: 1 },
            { type: 'track', section: '«порхающие» тридцатьвторые', trackNum: 13, duration: '0:17', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Главная тема менуэта', trackNum: 14, duration: '1:14', indentLevel: 1 },
            { type: 'track', section: 'Тема трио', trackNum: 15, duration: '1:46', indentLevel: 1 },
            { type: 'subheading', section: 'IV часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 17, duration: '1:37', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 18, duration: '0:43', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 19, duration: '0:31', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 20, duration: '1:36', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 21, duration: '2:09', indentLevel: 1 },
        ],
    },
    {
        num: 31,
        authorTitle: 'Л. ван Бетховен. Соната до минор, № 8',
        performer: 'Э. Гилельс (фортепиано)',
        tracks: [{ trackNum: 23, duration: '0:48' }, { trackNum: 25, duration: '1:04' }, { trackNum: 27, duration: '0:13' }, { trackNum: 29, duration: '0:20' }, { trackNum: 31, duration: '0:33' }, { trackNum: 33, duration: '0:40' }, { trackNum: 35, duration: '1:00' }, { trackNum: 37, duration: '0:46' }, { trackNum: 39, duration: '2:25' }, { trackNum: 41, duration: '0:37' }, { trackNum: 43, duration: '0:37' }, { trackNum: 45, duration: '0:29' }, { trackNum: 47, duration: '0:21' }, { trackNum: 49, duration: '0:20' }, { trackNum: 51, duration: '1:59' }, { trackNum: 53, duration: '0:25' }, { trackNum: 55, duration: '1:49' }, { trackNum: 57, duration: '1:00' }, { trackNum: 59, duration: '0:59' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Вступление:', indentLevel: 1 },
            { type: 'track', section: 'Вступление', trackNum: 23, duration: '0:48', indentLevel: 2 },
            { type: 'track', section: 'Вступление', trackNum: 25, duration: '1:04', indentLevel: 2 },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 27, duration: '0:13', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 29, duration: '0:20', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 31, duration: '0:33', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 33, duration: '0:40', indentLevel: 1 },
            { type: 'track', section: 'Тема вступления перед разработкой', trackNum: 35, duration: '1:00', indentLevel: 1 },
            { type: 'track', section: 'Разработка', trackNum: 37, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 39, duration: '2:25', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'Первая тема', trackNum: 41, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Проведение 1 темы октавой выше', trackNum: 43, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Вторая тема', trackNum: 45, duration: '0:29', indentLevel: 1 },
            { type: 'track', section: 'Третья тема', trackNum: 47, duration: '0:21', indentLevel: 1 },
            { type: 'track', section: 'Кульминация третьей темы', trackNum: 49, duration: '0:20', indentLevel: 1 },
            { type: 'track', section: 'Реприза и кода', trackNum: 51, duration: '1:59', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Тема рефрена', trackNum: 53, duration: '0:25', indentLevel: 1 },
            { type: 'track', section: 'Первый и третий эпизоды', trackNum: 55, duration: '1:49', indentLevel: 1 },
            { type: 'track', section: 'Второй эпизод', trackNum: 57, duration: '1:00', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 59, duration: '0:59', indentLevel: 1 },
        ],
    },
    {
        num: 32,
        authorTitle: 'Л. ван Бетховен. Симфония до минор, № 5',
        performer: 'Симф. орк. Берлинской филармонии Дир. Г. фон Караян',
        tracks: [{ trackNum: 61, duration: '0:08' }, { trackNum: 63, duration: '0:39' }, { trackNum: 65, duration: '0:24' }, { trackNum: 67, duration: '0:20' }, { trackNum: 69, duration: '1:22' }, { trackNum: 71, duration: '0:16' }, { trackNum: 73, duration: '1:28' }, { trackNum: 75, duration: '0:50' }, { trackNum: 77, duration: '1:02' }, { trackNum: 79, duration: '0:18' }, { trackNum: 81, duration: '0:07' }, { trackNum: 83, duration: '1:15' }, { trackNum: 85, duration: '1:37' }, { trackNum: 87, duration: '0:19' }, { trackNum: 89, duration: '0:20' }, { trackNum: 91, duration: '0:17' }, { trackNum: 92, duration: '1:41' }, { trackNum: 93, duration: '2:34' }, { trackNum: 94, duration: '0:43' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Тема - эпиграф', trackNum: 61, duration: '0:08', indentLevel: 2 },
            { type: 'track', section: 'Главная партия', trackNum: 63, duration: '0:39', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 65, duration: '0:24', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 67, duration: '0:20', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 69, duration: '1:22', indentLevel: 1 },
            { type: 'track', section: 'Реприза: соло гобоя', trackNum: 71, duration: '0:16', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 73, duration: '1:28', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'Первая тема вариаций', trackNum: 75, duration: '0:50', indentLevel: 1 },
            { type: 'track', section: 'Вторая тема вариаций', trackNum: 77, duration: '1:02', indentLevel: 1 },
            { type: 'track', section: 'Модуляция во второй теме', trackNum: 79, duration: '0:18', indentLevel: 1 },
            { type: 'track', section: 'Первая вариация на вторую тему («мотив эпиграф»)', trackNum: 81, duration: '0:07', indentLevel: 1 },
            { type: 'track', section: 'Четвертая вариация на первую тему', trackNum: 83, duration: '1:15', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 85, duration: '1:37', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Первая тема первого раздела', trackNum: 87, duration: '0:19', indentLevel: 1 },
            { type: 'track', section: 'Вторая тема первого раздела', trackNum: 89, duration: '0:20', indentLevel: 1 },
            { type: 'track', section: 'Тема трио', trackNum: 91, duration: '0:17', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 92, duration: '1:41', indentLevel: 1 },
            { type: 'track', section: 'Переход от скерцо к финалу и главная партия IV части', trackNum: 93, duration: '2:34', indentLevel: 1 },
            { type: 'track', section: 'Мотив - эпиграф в конце разработки финала', trackNum: 94, duration: '0:43', indentLevel: 1 },
        ],
    },
    {
        num: 33,
        authorTitle: 'Л. ван Бетховен. Увертюра «Эгмонт»',
        performer: 'Симф. орк. Берлинской филармонии Дир. Г. фон Караян',
        tracks: [{ trackNum: 95, duration: '0:24' }, { trackNum: 96, duration: '0:22' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Вступление:' },
            { type: 'track', section: 'Первая тема', trackNum: 95, duration: '0:24', indentLevel: 1 },
            { type: 'track', section: 'Вторая тема', trackNum: 96, duration: '0:22', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_5_DISK4 = [
    {
        num: 33,
        authorTitle: 'Л. ван Бетховен. Увертюра «Эгмонт» (продолжение)',
        performer: 'Симф. орк. Берлинской филармонии Дир. Г. фон Караян',
        tracks: [{ trackNum: 1, duration: '0:44' }, { trackNum: 2, duration: '1:21' }, { trackNum: 3, duration: '0:42' }, { trackNum: 4, duration: '0:28' }, { trackNum: 5, duration: '0:54' }, { trackNum: 6, duration: '1:33' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Вступление:' },
            { type: 'track', section: 'Третья тема', trackNum: 1, duration: '0:44', indentLevel: 1 },
            { type: 'subheading', section: 'Сонатное Allegro:' },
            { type: 'track', section: 'Главная партия', trackNum: 2, duration: '1:21', indentLevel: 1 },
            { type: 'track', section: 'Побочная партия', trackNum: 3, duration: '0:42', indentLevel: 1 },
            { type: 'track', section: 'Главная партия в разработке', trackNum: 4, duration: '0:28', indentLevel: 1 },
            { type: 'track', section: 'Конец репризы', trackNum: 5, duration: '0:54', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 6, duration: '1:33', indentLevel: 1 },
        ],
    },
    {
        num: 34,
        authorTitle: 'Ф. Шуберт. Маргарита за прялкой. Сл. И. Гете (из «Фауста»)',
        performer: 'Р. Флеминг',
        tracks: [{ trackNum: 7, duration: '5:43' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Маргарита за прялкой', trackNum: 7, duration: '5:43', indentLevel: 0 },
        ],
    },
    {
        num: 35,
        authorTitle: 'Ф. Шуберт. Лесной царь. Сл. И. Гете, перевод В. Жуковского',
        performer: 'Д. Гнатюк',
        tracks: [{ trackNum: 8, duration: '1:47' }, { trackNum: 9, duration: '0:56' }, { trackNum: 10, duration: '1:46' }, { trackNum: 11, duration: '0:29' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'диалог героев', trackNum: 8, duration: '1:47', indentLevel: 1 },
            { type: 'track', section: 'фортепианное вступление', trackNum: 9, duration: '0:56', indentLevel: 1 },
            { type: 'track', section: 'развитие на фоне фортепианного сопровождения', trackNum: 10, duration: '1:46', indentLevel: 1 },
            { type: 'track', section: 'финальная речитативная реплика «от автора»', trackNum: 11, duration: '0:29', indentLevel: 1 },
        ],
    },
    {
        num: 36,
        authorTitle: 'Ф. Шуберт. Вечерняя серенада. Сл. Л. Рельштаба',
        performer: 'Д. Фишер-Дискау',
        tracks: [{ trackNum: 12, duration: '1:40' }, { trackNum: 13, duration: '0:49' }, { trackNum: 14, duration: '0:29' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Первый куплет', trackNum: 12, duration: '1:40', indentLevel: 1 },
            { type: 'track', section: 'Сопоставление маж. и мин. в вокальной партии', trackNum: 13, duration: '0:49', indentLevel: 1 },
            { type: 'track', section: 'Сопоставление маж. и мин. у фортепиано', trackNum: 14, duration: '0:29', indentLevel: 1 },
        ],
    },
    {
        num: 37,
        authorTitle: 'Ф. Шуберт. Ave Maria. Сл. В. Скотта',
        performer: 'Р. Флеминг',
        tracks: [{ trackNum: 15, duration: '3:53' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Ave Maria', trackNum: 15, duration: '3:53', indentLevel: 0 },
        ],
    },
    {
        num: 38,
        authorTitle: 'Ф. Шуберт. Форель',
        performer: 'С. Лемешев',
        tracks: [{ trackNum: 16, duration: '0:47' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Форель', trackNum: 16, duration: '0:47', indentLevel: 0 },
        ],
    },
    {
        num: 39,
        authorTitle: 'Ф. Шуберт. Вокальный цикл «Прекрасная мельничиха». Сл. В. Мюллера',
        performer: 'Э. Хаефлигер',
        tracks: [{ trackNum: 17, duration: '1:59' }, { trackNum: 18, duration: '1:58' }, { trackNum: 19, duration: '1:19' }, { trackNum: 20, duration: '1:24' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'В путь (1 куплет)', trackNum: 17, duration: '1:59', indentLevel: 1 },
            { type: 'subheading', section: 'Мельник и ручей', indentLevel: 1 },
            { type: 'track', section: 'первая часть', trackNum: 18, duration: '1:58', indentLevel: 2 },
            { type: 'track', section: 'средняя часть', trackNum: 19, duration: '1:19', indentLevel: 2 },
            { type: 'track', section: '3 часть (реприза)', trackNum: 20, duration: '1:24', indentLevel: 2 },
        ],
    },
    {
        num: 40,
        authorTitle: 'Ф. Шуберт. Цикл «Зимний путь». Сл. Мюллера',
        performer: 'Э. Хаефлигер',
        tracks: [{ trackNum: 21, duration: '2:07' }, { trackNum: 22, duration: '1:12' }, { trackNum: 23, duration: '0:47' }, { trackNum: 24, duration: '1:43' }, { trackNum: 25, duration: '1:11' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Спокойно спи', trackNum: 21, duration: '2:07', indentLevel: 1 },
            { type: 'track', section: 'Весенний сон', trackNum: 22, duration: '1:12', indentLevel: 1 },
            { type: 'subheading', section: 'Шарманщик', indentLevel: 1 },
            { type: 'track', section: 'фортепианное вступление', trackNum: 23, duration: '0:47', indentLevel: 2 },
            { type: 'track', section: '1 куплет', trackNum: 24, duration: '1:43', indentLevel: 2 },
            { type: 'track', section: 'последний куплет', trackNum: 25, duration: '1:11', indentLevel: 2 },
        ],
    },
    {
        num: 41,
        authorTitle: 'Ф. Шуберт. Вальс си минор',
        performer: 'И. Морао (фортепиано)',
        tracks: [{ trackNum: 26, duration: '1:47' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вальс си минор', trackNum: 26, duration: '1:47', indentLevel: 0 },
        ],
    },
    {
        num: 42,
        authorTitle: 'Ф. Шуберт. Музыкальный момент фа минор',
        performer: 'С. Капова (фортепиано)',
        tracks: [{ trackNum: 27, duration: '2:53' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Музыкальный момент фа минор', trackNum: 27, duration: '2:53', indentLevel: 0 },
        ],
    },
    {
        num: 43,
        authorTitle: 'Ф. Шуберт. Экспромт ми бемоль мажор',
        performer: 'М. Пиррахиа (фортепиано)',
        tracks: [{ trackNum: 28, duration: '1:29' }, { trackNum: 29, duration: '0:39' }, { trackNum: 30, duration: '0:40' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Первый раздел', trackNum: 28, duration: '1:29', indentLevel: 1 },
            { type: 'track', section: 'Средний раздел', trackNum: 29, duration: '0:39', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 30, duration: '0:40', indentLevel: 1 },
        ],
    },
    {
        num: 44,
        authorTitle: 'Ф. Шуберт. Симфония №8 си минор',
        performer: 'Берлинский симф. орк. Дир. К.- А. Бюнте',
        tracks: [{ trackNum: 31, duration: '1:39' }, { trackNum: 32, duration: '1:41' }, { trackNum: 33, duration: '0:46' }, { trackNum: 34, duration: '1:46' }, { trackNum: 35, duration: '0:29' }, { trackNum: 36, duration: '1:03' }, { trackNum: 37, duration: '0:41' }, { trackNum: 38, duration: '0:48' }, { trackNum: 39, duration: '1:03' }, { trackNum: 40, duration: '0:53' }, { trackNum: 41, duration: '2:16' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'track', section: 'Вступление', trackNum: 31, duration: '1:39', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 32, duration: '1:41', indentLevel: 1 },
            { type: 'track', section: 'Побочная партия', trackNum: 33, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Перелом в побочной партии', trackNum: 34, duration: '1:46', indentLevel: 1 },
            { type: 'track', section: 'Заключительная партия', trackNum: 35, duration: '0:29', indentLevel: 1 },
            { type: 'track', section: 'Разработка', trackNum: 36, duration: '1:03', indentLevel: 1 },
            { type: 'track', section: 'Трансформация п.п. в разработке', trackNum: 37, duration: '0:41', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 38, duration: '0:48', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'Главная партия', trackNum: 39, duration: '1:03', indentLevel: 1 },
            { type: 'track', section: 'Побочная партия', trackNum: 40, duration: '0:53', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 41, duration: '2:16', indentLevel: 1 },
        ],
    },
    {
        num: 45,
        authorTitle: 'Ф. Шопен. Мазурка До мажор. Ор. 56, №2',
        performer: 'Е. Кисин (фортепиано)',
        tracks: [{ trackNum: 42, duration: '2:23' }, { trackNum: 43, duration: '0:37' }, { trackNum: 44, duration: '0:28' }, { trackNum: 45, duration: '0:36' }, { trackNum: 46, duration: '0:26' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Первое коленце', trackNum: 42, duration: '2:23', indentLevel: 1 },
            { type: 'track', section: 'Второе коленце', trackNum: 43, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Третий раздел', trackNum: 44, duration: '0:28', indentLevel: 1 },
            { type: 'track', section: '«Мельница» в лидийском ладу', trackNum: 45, duration: '0:36', indentLevel: 1 },
            { type: 'track', section: 'Заключение', trackNum: 46, duration: '0:26', indentLevel: 1 },
        ],
    },
    {
        num: 46,
        authorTitle: 'Ф. Шопен. Мазурка Си бемоль мажор. Ор. 7, №1',
        performer: 'Я. Олежничек (фортепиано)',
        tracks: [{ trackNum: 47, duration: '1:08' }, { trackNum: 48, duration: '0:26' }, { trackNum: 49, duration: '0:32' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'І раздел', trackNum: 47, duration: '1:08', indentLevel: 1 },
            { type: 'track', section: '1 эпизод', trackNum: 48, duration: '0:26', indentLevel: 2 },
            { type: 'track', section: '2 эпизод', trackNum: 49, duration: '0:32', indentLevel: 2 },
        ],
    },
    {
        num: 47,
        authorTitle: 'Ф. Шопен. Мазурка ля минор. Ор. 68, №2.',
        performer: 'Я. Олежничек (фортепиано)',
        tracks: [{ trackNum: 50, duration: '2:06' }, { trackNum: 51, duration: '1:03' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 раздел', trackNum: 50, duration: '2:06', indentLevel: 1 },
            { type: 'track', section: 'Средняя часть', trackNum: 51, duration: '1:03', indentLevel: 1 },
        ],
    },
    {
        num: 48,
        authorTitle: 'Ф. Шопен. Полонез Ля мажор. Ор. 40, №1.',
        performer: 'Я. Олежничек (фортепиано)',
        tracks: [{ trackNum: 52, duration: '2:06' }, { trackNum: 53, duration: '3:55' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 часть', trackNum: 52, duration: '2:06', indentLevel: 1 },
            { type: 'track', section: 'Средний раздел и реприза', trackNum: 53, duration: '3:55', indentLevel: 1 },
        ],
    },
    {
        num: 49,
        authorTitle: 'Ф. Шопен. Вальс до-диез минор. Ор. 64, №2',
        performer: 'Т. Шебанова (фортепиано)',
        tracks: [{ trackNum: 54, duration: '1:58' }, { trackNum: 55, duration: '0:42' }, { trackNum: 56, duration: '0:39' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Темы 1 и 3 частей', trackNum: 54, duration: '1:58', indentLevel: 1 },
            { type: 'track', section: 'Тема 2 части', trackNum: 55, duration: '0:42', indentLevel: 1 },
            { type: 'track', section: 'Завершающий припев', trackNum: 56, duration: '0:39', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_5_DISK5 = [
    {
        num: 50,
        authorTitle: 'Ф. Шопен. Прелюдия ми минор',
        performer: 'С. Рихтер (фортепиано)',
        tracks: [{ trackNum: 2, duration: '0:30' }, { trackNum: 4, duration: '0:08' }, { trackNum: 6, duration: '0:25' }, { trackNum: 8, duration: '2:06' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'начало 1-го предложения', trackNum: 2, duration: '0:30', indentLevel: 1 },
            { type: 'track', section: 'окончание 1-го предложения', trackNum: 4, duration: '0:08', indentLevel: 1 },
            { type: 'track', section: 'кульминация', trackNum: 6, duration: '0:25', indentLevel: 1 },
            { type: 'track', section: 'прелюдия полностью', trackNum: 8, duration: '2:06', indentLevel: 1 },
        ],
    },
    {
        num: 51,
        authorTitle: 'Ф. Шопен. Прелюдия Ля мажор',
        performer: 'С. Рихтер (фортепиано)',
        tracks: [{ trackNum: 10, duration: '0:59' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Прелюдия Ля мажор', trackNum: 10, duration: '0:59', indentLevel: 0 }],
    },
    {
        num: 52,
        authorTitle: 'Ф. Шопен. Прелюдия до минор',
        performer: 'И. Жуков (фортепиано)',
        tracks: [{ trackNum: 12, duration: '1:56' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Прелюдия до минор', trackNum: 12, duration: '1:56', indentLevel: 0 }],
    },
    {
        num: 53,
        authorTitle: 'Ф. Шопен. Ноктюрн фа минор',
        performer: 'С. Фалвей (фортепиано)',
        tracks: [{ trackNum: 14, duration: '2:12' }, { trackNum: 16, duration: '0:46' }, { trackNum: 18, duration: '1:06' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 раздел', trackNum: 14, duration: '2:12', indentLevel: 1 },
            { type: 'track', section: 'средняя часть', trackNum: 16, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'реприза и кода', trackNum: 18, duration: '1:06', indentLevel: 1 },
        ],
    },
    {
        num: 54,
        authorTitle: 'Ф. Шопен. Этюд до минор. Ор. 10, №12 «Революционный»',
        performer: 'А. Скавронский (фортепиано)',
        tracks: [{ trackNum: 20, duration: '2:32' }, { trackNum: 22, duration: '0:20' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'основной раздел', trackNum: 20, duration: '2:32', indentLevel: 1 },
            { type: 'track', section: 'кода', trackNum: 22, duration: '0:20', indentLevel: 1 },
        ],
    },
    {
        num: 55,
        authorTitle: 'Ф. Шопен. Этюд ми мажор. Ор. 10, №3',
        performer: 'А. Скавронский (фортепиано)',
        tracks: [{ trackNum: 24, duration: '1:40' }, { trackNum: 26, duration: '3:17' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 часть', trackNum: 24, duration: '1:40', indentLevel: 1 },
            { type: 'track', section: 'средняя часть и реприза', trackNum: 26, duration: '3:17', indentLevel: 1 },
        ],
    },
    {
        num: 56,
        authorTitle: 'Дж. Россини. Опера «Севильский цирюльник»',
        performer: 'Bayern radio symphony orchestra. Дир. Б. Бартолетти',
        tracks: [{ trackNum: 28, duration: '1:34' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Ария Фигаро', trackNum: 28, duration: '1:34', indentLevel: 0 }],
    },
    {
        num: 57,
        authorTitle: 'В. Беллини. Опера «Норма»',
        performer: 'Хор и орк. EIAR',
        tracks: [{ trackNum: 30, duration: '1:46' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Ария Нормы «Casta Diva»', trackNum: 30, duration: '1:46', indentLevel: 0 }],
    },
    {
        num: 58,
        authorTitle: 'Дж. Верди. Опера «Травиата»',
        performer: 'Хор Мюнхена, Нюрнбергский симф. орк. Дир. А. вон Питамик',
        tracks: [{ trackNum: 32, duration: '1:14' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Застольная песня Альфреда', trackNum: 32, duration: '1:14', indentLevel: 0 }],
    },
    {
        num: 59,
        authorTitle: 'Р. Леонкавалло. Опера «Паяцы»',
        performer: 'В. Атлантов',
        tracks: [{ trackNum: 34, duration: '2:00' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Ария Канио', trackNum: 34, duration: '2:00', indentLevel: 0 }],
    },
    {
        num: 60,
        authorTitle: 'Г. Берлиоз. Фантастическая симфония',
        performer: 'Судецкая филармония. Дир. А. Лиццио',
        tracks: [{ trackNum: 36, duration: '2:13' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Часть ІІ. Тема вальса', trackNum: 36, duration: '2:13', indentLevel: 0 }],
    },
    {
        num: 61,
        authorTitle: 'Ж. Бизе. Опера «Кармен». Акт І',
        performer: 'Лондонский филармонический орк. Дир. Г. Солти',
        tracks: [{ trackNum: 38, duration: '2:14' }, { trackNum: 40, duration: '2:10' }, { trackNum: 42, duration: '0:37' }, { trackNum: 44, duration: '0:44' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Хабанера', trackNum: 38, duration: '2:14', indentLevel: 1 },
            { type: 'track', section: 'Сегидилья', trackNum: 40, duration: '2:10', indentLevel: 1 },
            { type: 'track', section: 'Тема роковой любви', trackNum: 42, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Тема куплетов тореадора', trackNum: 44, duration: '0:44', indentLevel: 1 },
        ],
    },
    {
        num: 62,
        authorTitle: 'Ж. Оффенбах. Увертюра к оперетте «Парижская жизнь»',
        performer: 'Лондонский филарм. орк. Дир. А. Сколз',
        tracks: [{ trackNum: 46, duration: '1:28' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Увертюра к оперетте «Парижская жизнь»', trackNum: 46, duration: '1:28', indentLevel: 0 }],
    },
    {
        num: 63,
        authorTitle: 'К. Дебюсси. Послеполуденный отдых Фавна',
        performer: 'Симф. орк. Вены',
        tracks: [{ trackNum: 48, duration: '2:29' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Послеполуденный отдых Фавна', trackNum: 48, duration: '2:29', indentLevel: 0 }],
    },
    {
        num: 64,
        authorTitle: 'М. Равель. Болеро',
        performer: 'Симф. орк. Люблянского радио. Дир. А. Нанут',
        tracks: [{ trackNum: 50, duration: '0:50' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Болеро', trackNum: 50, duration: '0:50', indentLevel: 0 }],
    },
    {
        num: 65,
        authorTitle: 'М. Равель. Ундина',
        performer: 'Е. Могилевский',
        tracks: [{ trackNum: 52, duration: '1:08' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Ундина', trackNum: 52, duration: '1:08', indentLevel: 0 }],
    },
    {
        num: 66,
        authorTitle: 'И. Штраус. Вальс «Весенние голоса»',
        performer: 'Лондонский филарм. орк. Дир. А. Шольц',
        tracks: [{ trackNum: 54, duration: '0:54' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Вальс «Весенние голоса»', trackNum: 54, duration: '0:54', indentLevel: 0 }],
    },
    {
        num: 67,
        authorTitle: 'И. Брамс. Симфония № 3',
        performer: 'Королевский симф. орк. Ливерпуля. Дир. М. Яновски',
        tracks: [{ trackNum: 56, duration: '1:48' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Часть III', trackNum: 56, duration: '1:48', indentLevel: 0 }],
    },
    {
        num: 68,
        authorTitle: 'Г. Малер. Симфония № 5',
        performer: 'Симф. орк. Люблянского радио',
        tracks: [{ trackNum: 58, duration: '2:00' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Траурный марш', trackNum: 58, duration: '2:00', indentLevel: 0 }],
    },
    {
        num: 69,
        authorTitle: 'Р. Вагнер. Опера «Валькирии»',
        performer: 'Байрейтский филарм. орк. Дир. Ю. Орманди',
        tracks: [{ trackNum: 60, duration: '1:34' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Полет Валькирий', trackNum: 60, duration: '1:34', indentLevel: 0 }],
    },
    {
        num: 70,
        authorTitle: 'Ф. Мендельсон. Музыка к комедии Шекспира «Сон в летнюю ночь». Свадебный марш',
        performer: 'Словакская филармония. Дир. А. Лиццио',
        tracks: [{ trackNum: 62, duration: '0:42' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Свадебный марш', trackNum: 62, duration: '0:42', indentLevel: 0 }],
    },
    {
        num: 71,
        authorTitle: 'Ф. Мендельсон. Песня без слов. № 30 «Весенняя»',
        performer: 'Х. Гейл (фортепиано)',
        tracks: [{ trackNum: 64, duration: '0:28' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Песня без слов № 30', trackNum: 64, duration: '0:28', indentLevel: 0 }],
    },
    {
        num: 72,
        authorTitle: 'Р. Шуман. Карнавал. Шопен',
        performer: 'К. Аррау (фортепиано)',
        tracks: [{ trackNum: 66, duration: '0:38' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Шопен', trackNum: 66, duration: '0:38', indentLevel: 0 }],
    },
    {
        num: 73,
        authorTitle: 'Р. Шуман. Детские сцены. Грезы',
        performer: 'К. Аррау (фортепиано)',
        tracks: [{ trackNum: 68, duration: '1:09' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Грезы', trackNum: 68, duration: '1:09', indentLevel: 0 }],
    },
    {
        num: 74,
        authorTitle: 'Ф. Лист. Этюд «Мазепа»',
        performer: 'Й. Боллет (фортепиано)',
        tracks: [{ trackNum: 70, duration: '0:49' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Этюд «Мазепа»', trackNum: 70, duration: '0:49', indentLevel: 0 }],
    },
    {
        num: 75,
        authorTitle: 'Дворжак. Симфония № 9',
        performer: 'Словакский филарм. орк. Дир. Кослер',
        tracks: [{ trackNum: 72, duration: '0:24' }, { trackNum: 74, duration: '0:26' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 часть. Побочная партия', trackNum: 72, duration: '0:24', indentLevel: 1 },
            { type: 'track', section: '2 часть', trackNum: 74, duration: '0:26', indentLevel: 1 },
        ],
    },
    {
        num: 76,
        authorTitle: 'М. де Фалья. Балет «Треуголка». Часть ІІІ. Фанданго',
        performer: 'Orchester de la Suisse Romande',
        tracks: [{ trackNum: 76, duration: '1:04' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Фанданго', trackNum: 76, duration: '1:04', indentLevel: 0 }],
    },
    {
        num: 77,
        authorTitle: 'Э. Элгар. «Энигма». Вариация Нимрод',
        performer: 'Лондонский симф. орк. Дир. Г. Рихтер',
        tracks: [{ trackNum: 78, duration: '4:08' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Вариация Нимрод', trackNum: 78, duration: '4:08', indentLevel: 0 }],
    },
    {
        num: 78,
        authorTitle: 'Я. Сибелиус. Поэма «Финляндия»',
        performer: 'Радио Братиславы. Дир. Р. Станковский',
        tracks: [{ trackNum: 80, duration: '1:01' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Поэма «Финляндия»', trackNum: 80, duration: '1:01', indentLevel: 0 }],
    },
];

const TABLE_CONTENT_5_DISK6 = [
    {
        num: 1,
        authorTitle: 'Анонимный григорианский хорал. ІХ век',
        performer: 'Ансамбль «Schola cantorum»',
        tracks: [{ trackNum: 2, duration: '4:02' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Григорианский хорал', trackNum: 2, duration: '4:02', indentLevel: 0 }],
    },
    {
        num: 2,
        authorTitle: 'Г. де Машо. Месса Нотр-Дам. «Sanctus»',
        performer: 'Женская группа камерного хора. Дир. В. Нестеров',
        tracks: [{ trackNum: 4, duration: '4:57' }],
        rows: [{ type: 'title' }, { type: 'track', section: '«Sanctus»', trackNum: 4, duration: '4:57', indentLevel: 0 }],
    },
    {
        num: 3,
        authorTitle: 'И. Окегем. Мотет «Intermerata Dei Mater»',
        performer: 'Оксфордская Камерата',
        tracks: [{ trackNum: 6, duration: '7:59' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Мотет «Intermerata Dei Mater»', trackNum: 6, duration: '7:59', indentLevel: 0 }],
    },
    {
        num: 4,
        authorTitle: 'Ф. да Милано. Фантазия для лютни',
        performer: 'Х. Вильсон',
        tracks: [{ trackNum: 8, duration: '5:02' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Фантазия для лютни', trackNum: 8, duration: '5:02', indentLevel: 0 }],
    },
    {
        num: 5,
        authorTitle: 'Г. Ф. Гендель. Concerto grosso № 6, g-moll',
        performer: 'Мюнхенский Баховский орк. Дир. Я. Шредер',
        tracks: [{ trackNum: 10, duration: '3:20' }, { trackNum: 11, duration: '1:37' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 часть', trackNum: 10, duration: '3:20', indentLevel: 1 },
            { type: 'track', section: '2 часть', trackNum: 11, duration: '1:37', indentLevel: 1 },
        ],
    },
    {
        num: 6,
        authorTitle: 'И. С. Бах. Хоральная прелюдия фа минор',
        performer: 'Л. Рогг (орган)',
        tracks: [{ trackNum: 13, duration: '2:13' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Хоральная прелюдия фа минор', trackNum: 13, duration: '2:13', indentLevel: 0 }],
    },
    {
        num: 7,
        authorTitle: 'И. С. Бах. Токката и фуга ре минор:',
        performer: 'О. Винтер (орган)',
        tracks: [{ trackNum: 15, duration: '2:20' }, { trackNum: 16, duration: '5:39' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'токката', trackNum: 15, duration: '2:20', indentLevel: 1 },
            { type: 'track', section: 'фуга', trackNum: 16, duration: '5:39', indentLevel: 1 },
        ],
    },
    {
        num: 8,
        authorTitle: 'И. С. Бах. Хорошо темперированный клавир. Том І. Прелюдия и фуга соль минор:',
        performer: 'С. Рихтер (фортепиано)',
        tracks: [{ trackNum: 18, duration: '1:57' }, { trackNum: 19, duration: '2:55' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'прелюдия', trackNum: 18, duration: '1:57', indentLevel: 1 },
            { type: 'track', section: 'фуга', trackNum: 19, duration: '2:55', indentLevel: 1 },
        ],
    },
    {
        num: 9,
        authorTitle: 'И. С. Бах. Французская сюита до минор',
        performer: 'Г. Гульд (фортепиано)',
        tracks: [{ trackNum: 21, duration: '2:34' }, { trackNum: 22, duration: '1:07' }, { trackNum: 23, duration: '2:13' }, { trackNum: 24, duration: '1:42' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Аллеманда', trackNum: 21, duration: '2:34', indentLevel: 1 },
            { type: 'track', section: 'Куранта', trackNum: 22, duration: '1:07', indentLevel: 1 },
            { type: 'track', section: 'Сарабанда', trackNum: 23, duration: '2:13', indentLevel: 1 },
            { type: 'track', section: 'Жига', trackNum: 24, duration: '1:42', indentLevel: 1 },
        ],
    },
    {
        num: 10,
        authorTitle: 'И. С. Бах. Месса си минор. Хор №17 Crucifixus',
        performer: 'Берлинский филарм. орк. Дир. Г. фон Караян',
        tracks: [{ trackNum: 26, duration: '2:40' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Хор №17 Crucifixus', trackNum: 26, duration: '2:40', indentLevel: 0 }],
    },
    {
        num: 11,
        authorTitle: 'Й. Гайдн. Соната ми минор',
        performer: 'Дж. Маккейб (фортепиано)',
        tracks: [{ trackNum: 28, duration: '0:15' }, { trackNum: 29, duration: '0:32' }, { trackNum: 30, duration: '0:19' }, { trackNum: 31, duration: '0:05' }, { trackNum: 32, duration: '1:14' }, { trackNum: 33, duration: '0:52' }, { trackNum: 34, duration: '1:14' }, { trackNum: 35, duration: '2:13' }, { trackNum: 36, duration: '5:19' }, { trackNum: 37, duration: '0:38' }, { trackNum: 38, duration: '0:45' }, { trackNum: 39, duration: '1:07' }, { trackNum: 40, duration: '0:26' }, { trackNum: 41, duration: '0:39' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: '1 часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 28, duration: '0:15', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 29, duration: '0:32', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 30, duration: '0:19', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 31, duration: '0:05', indentLevel: 2 },
            { type: 'track', section: 'Повторение экспозиции', trackNum: 32, duration: '1:14', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 33, duration: '0:52', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 34, duration: '1:14', indentLevel: 1 },
            { type: 'track', section: 'Повторение разработки и репризы', trackNum: 35, duration: '2:13', indentLevel: 1 },
            { type: 'track', section: '2 часть', trackNum: 36, duration: '5:19', indentLevel: 1 },
            { type: 'subheading', section: '3 часть:' },
            { type: 'track', section: 'Рефрен', trackNum: 37, duration: '0:38', indentLevel: 1 },
            { type: 'track', section: 'Первый эпизод', trackNum: 38, duration: '0:45', indentLevel: 1 },
            { type: 'track', section: 'Рефрен', trackNum: 39, duration: '1:07', indentLevel: 1 },
            { type: 'track', section: 'Второй эпизод', trackNum: 40, duration: '0:26', indentLevel: 1 },
            { type: 'track', section: 'Рефрен', trackNum: 41, duration: '0:39', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_5_DISK7 = [
    {
        num: 12,
        authorTitle: 'Й. Гайдн. Соната Ре мажор',
        performer: 'А. Стайер (фортепиано)',
        tracks: [{ trackNum: 2, duration: '0:14' }, { trackNum: 3, duration: '0:13' }, { trackNum: 4, duration: '0:30' }, { trackNum: 5, duration: '0:10' }, { trackNum: 6, duration: '1:08' }, { trackNum: 7, duration: '0:35' }, { trackNum: 8, duration: '0:32' }, { trackNum: 9, duration: '0:43' }, { trackNum: 10, duration: '2:31' }, { trackNum: 11, duration: '0:33' }, { trackNum: 12, duration: '0:37' }, { trackNum: 13, duration: '0:32' }, { trackNum: 14, duration: '0:45' }, { trackNum: 15, duration: '0:34' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 2, duration: '0:14', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 3, duration: '0:13', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 4, duration: '0:30', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 5, duration: '0:10', indentLevel: 2 },
            { type: 'track', section: 'Повторение экспозиции', trackNum: 6, duration: '1:08', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 7, duration: '0:35', indentLevel: 1 },
            { type: 'subheading', section: 'Реприза:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 8, duration: '0:32', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 9, duration: '0:43', indentLevel: 2 },
            { type: 'track', section: 'ІІ часть', trackNum: 10, duration: '2:31', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Рефрен', trackNum: 11, duration: '0:33', indentLevel: 1 },
            { type: 'track', section: 'Первый эпизод', trackNum: 12, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Рефрен', trackNum: 13, duration: '0:32', indentLevel: 1 },
            { type: 'track', section: 'Второй эпизод', trackNum: 14, duration: '0:45', indentLevel: 1 },
            { type: 'track', section: 'Рефрен', trackNum: 15, duration: '0:34', indentLevel: 1 },
        ],
    },
    {
        num: 13,
        authorTitle: 'Й. Гайдн. Симфония № 103 Ми – бемоль мажор',
        performer: 'Берлинский филарм. орк. Дир. Г. фон Караян',
        tracks: [{ trackNum: 17, duration: '3:06' }, { trackNum: 18, duration: '1:04' }, { trackNum: 19, duration: '1:51' }, { trackNum: 20, duration: '1:51' }, { trackNum: 21, duration: '1:14' }, { trackNum: 22, duration: '1:29' }, { trackNum: 23, duration: '2:20' }, { trackNum: 24, duration: '2:01' }, { trackNum: 25, duration: '1:27' }, { trackNum: 26, duration: '1:47' }, { trackNum: 27, duration: '1:29' }, { trackNum: 28, duration: '1:33' }, { trackNum: 29, duration: '0:37' }, { trackNum: 30, duration: '0:30' }, { trackNum: 31, duration: '2:32' }, { trackNum: 32, duration: '1:40' }, { trackNum: 33, duration: '1:17' }, { trackNum: 34, duration: '5:26' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 17, duration: '3:06', indentLevel: 0 },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 18, duration: '1:04', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия и повторение экспозиции', trackNum: 19, duration: '1:51', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 20, duration: '1:51', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 21, duration: '1:14', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 22, duration: '1:29', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'І тема вариаций', trackNum: 23, duration: '2:20', indentLevel: 1 },
            { type: 'track', section: 'ІІ тема вариаций', trackNum: 24, duration: '2:01', indentLevel: 1 },
            { type: 'track', section: '1-я вариация І темы', trackNum: 25, duration: '1:27', indentLevel: 2 },
            { type: 'track', section: '1-я вариация ІІ темы', trackNum: 26, duration: '1:47', indentLevel: 2 },
            { type: 'track', section: '2-я вариация І темы', trackNum: 27, duration: '1:29', indentLevel: 2 },
            { type: 'track', section: '2-я вариация ІІ темы', trackNum: 28, duration: '1:33', indentLevel: 2 },
            { type: 'subheading', section: 'Кода:', indentLevel: 1 },
            { type: 'track', section: 'предыкт коды', trackNum: 29, duration: '0:37', indentLevel: 2 },
            { type: 'track', section: 'центральный раздел коды', trackNum: 30, duration: '0:30', indentLevel: 2 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Первая часть', trackNum: 31, duration: '2:32', indentLevel: 1 },
            { type: 'track', section: 'Трио', trackNum: 32, duration: '1:40', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 33, duration: '1:17', indentLevel: 1 },
            { type: 'subheading', section: 'IV часть' },
            { type: 'track', section: 'IV часть', trackNum: 34, duration: '5:26', indentLevel: 1 },
        ],
    },
    {
        num: 14,
        authorTitle: 'В. А. Моцарт. Соната Ля мажор',
        performer: 'Ж.-Б. Поммье (фортепиано)',
        tracks: [{ trackNum: 36, duration: '1:50' }, { trackNum: 37, duration: '1:46' }, { trackNum: 38, duration: '1:37' }, { trackNum: 39, duration: '1:43' }, { trackNum: 44, duration: '0:48' }, { trackNum: 45, duration: '0:16' }, { trackNum: 46, duration: '0:46' }, { trackNum: 47, duration: '0:16' }, { trackNum: 48, duration: '0:48' }, { trackNum: 49, duration: '0:49' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'track', section: 'Тема вариаций', trackNum: 36, duration: '1:50', indentLevel: 1 },
            { type: 'track', section: '1-я вариация', trackNum: 37, duration: '1:46', indentLevel: 2 },
            { type: 'track', section: '2-я вариация', trackNum: 38, duration: '1:37', indentLevel: 2 },
            { type: 'track', section: '3-я вариация', trackNum: 39, duration: '1:43', indentLevel: 2 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Первая часть', trackNum: 44, duration: '0:48', indentLevel: 1 },
            { type: 'track', section: 'Припев', trackNum: 45, duration: '0:16', indentLevel: 1 },
            { type: 'track', section: 'Средняя часть', trackNum: 46, duration: '0:46', indentLevel: 1 },
            { type: 'track', section: 'Припев', trackNum: 47, duration: '0:16', indentLevel: 1 },
            { type: 'track', section: 'Повторение первой части', trackNum: 48, duration: '0:48', indentLevel: 1 },
            { type: 'track', section: 'Припев и кода', trackNum: 49, duration: '0:49', indentLevel: 1 },
        ],
    },
    {
        num: 15,
        authorTitle: 'В. А. Моцарт. Реквием. Lacrimosa',
        performer: 'Венский фил. хор. Дир. Ф. Гроссман',
        tracks: [{ trackNum: 51, duration: '3:26' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Реквием. Lacrimosa', trackNum: 51, duration: '3:26', indentLevel: 0 },
        ],
    },
];

const TABLE_CONTENT_5_DISK8 = [
    {
        num: 16,
        authorTitle: 'В. А. Моцарт. Симфония № 40, соль минор',
        performer: 'Берлинский филарм. орк. Дир. Г. фон Караян',
        tracks: [{ trackNum: 2, duration: '0:22' }, { trackNum: 3, duration: '0:24' }, { trackNum: 4, duration: '0:30' }, { trackNum: 5, duration: '0:31' }, { trackNum: 6, duration: '1:45' }, { trackNum: 7, duration: '1:11' }, { trackNum: 8, duration: '2:31' }, { trackNum: 9, duration: '7:42' }, { trackNum: 10, duration: '1:48' }, { trackNum: 11, duration: '1:52' }, { trackNum: 12, duration: '0:55' }, { trackNum: 13, duration: '1:02' }, { trackNum: 14, duration: '0:27' }, { trackNum: 15, duration: '0:21' }, { trackNum: 16, duration: '1:11' }, { trackNum: 17, duration: '1:34' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 2, duration: '0:22', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 3, duration: '0:24', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 4, duration: '0:30', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 5, duration: '0:31', indentLevel: 2 },
            { type: 'track', section: 'Повтор экспозиции', trackNum: 6, duration: '1:45', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 7, duration: '1:11', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 8, duration: '2:31', indentLevel: 1 },
            { type: 'track', section: 'ІІ часть', trackNum: 9, duration: '7:42', indentLevel: 0 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Первый раздел', trackNum: 10, duration: '1:48', indentLevel: 1 },
            { type: 'track', section: 'Трио', trackNum: 11, duration: '1:52', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 12, duration: '0:55', indentLevel: 1 },
            { type: 'subheading', section: 'IV часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 13, duration: '1:02', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 14, duration: '0:27', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 15, duration: '0:21', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 16, duration: '1:11', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 17, duration: '1:34', indentLevel: 1 },
        ],
    },
    {
        num: 17,
        authorTitle: 'Л. ван Бетховен. Соната до минор, № 8',
        performer: 'Э. Гилельс (фортепиано)',
        tracks: [{ trackNum: 19, duration: '1:48' }, { trackNum: 20, duration: '0:05' }, { trackNum: 21, duration: '0:24' }, { trackNum: 22, duration: '0:30' }, { trackNum: 23, duration: '0:38' }, { trackNum: 24, duration: '1:42' }, { trackNum: 25, duration: '0:45' }, { trackNum: 26, duration: '0:22' }, { trackNum: 27, duration: '0:21' }, { trackNum: 28, duration: '0:06' }, { trackNum: 29, duration: '0:15' }, { trackNum: 30, duration: '0:25' }, { trackNum: 31, duration: '0:42' }, { trackNum: 32, duration: '0:45' }, { trackNum: 33, duration: '0:11' }, { trackNum: 34, duration: '1:13' }, { trackNum: 35, duration: '1:30' }, { trackNum: 36, duration: '1:03' }, { trackNum: 37, duration: '1:55' }, { trackNum: 38, duration: '0:34' }, { trackNum: 39, duration: '0:53' }, { trackNum: 40, duration: '0:23' }, { trackNum: 41, duration: '0:59' }, { trackNum: 42, duration: '0:43' }, { trackNum: 43, duration: '0:28' }, { trackNum: 44, duration: '1:00' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'track', section: 'Вступление', trackNum: 19, duration: '1:48', indentLevel: 1 },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 20, duration: '0:05', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 21, duration: '0:24', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 22, duration: '0:30', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 23, duration: '0:38', indentLevel: 2 },
            { type: 'track', section: 'Повтор экспозиции', trackNum: 24, duration: '1:42', indentLevel: 1 },
            { type: 'track', section: 'Тема вступления перед разработкой', trackNum: 25, duration: '0:45', indentLevel: 1 },
            { type: 'track', section: 'Разработка', trackNum: 26, duration: '0:22', indentLevel: 1 },
            { type: 'track', section: 'Предыкт', trackNum: 27, duration: '0:21', indentLevel: 1 },
            { type: 'subheading', section: 'Реприза:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 28, duration: '0:06', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 29, duration: '0:15', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 30, duration: '0:25', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 31, duration: '0:42', indentLevel: 2 },
            { type: 'track', section: 'Тема вступления', trackNum: 32, duration: '0:45', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 33, duration: '0:11', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'Первая тема', trackNum: 34, duration: '1:13', indentLevel: 1 },
            { type: 'track', section: 'Вторая тема и повтор первой темы', trackNum: 35, duration: '1:30', indentLevel: 1 },
            { type: 'track', section: 'Третья тема', trackNum: 36, duration: '1:03', indentLevel: 1 },
            { type: 'track', section: 'Повтор первой темы и кода', trackNum: 37, duration: '1:55', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Тема рефрена (главная партия)', trackNum: 38, duration: '0:34', indentLevel: 1 },
            { type: 'track', section: 'Первый эпизод и побочная партия', trackNum: 39, duration: '0:53', indentLevel: 1 },
            { type: 'track', section: 'Рефрен', trackNum: 40, duration: '0:23', indentLevel: 1 },
            { type: 'track', section: 'Второй эпизод', trackNum: 41, duration: '0:59', indentLevel: 1 },
            { type: 'track', section: 'Рефрен (главная партия) и третий эпизод', trackNum: 42, duration: '0:43', indentLevel: 1 },
            { type: 'track', section: 'Побочная партия', trackNum: 43, duration: '0:28', indentLevel: 1 },
            { type: 'track', section: 'Рефрен и кода', trackNum: 44, duration: '1:00', indentLevel: 1 },
        ],
    },
    {
        num: 18,
        authorTitle: 'Л. ван Бетховен. Симфония до минор, № 5',
        performer: 'Берлинский филарм. орк. Дир. Г. фон Караян',
        tracks: [{ trackNum: 46, duration: '0:23' }, { trackNum: 47, duration: '0:20' }, { trackNum: 48, duration: '0:21' }, { trackNum: 49, duration: '1:45' }, { trackNum: 50, duration: '1:20' }, { trackNum: 51, duration: '0:53' }, { trackNum: 52, duration: '0:42' }, { trackNum: 53, duration: '1:27' }, { trackNum: 54, duration: '0:48' }, { trackNum: 55, duration: '0:58' }, { trackNum: 56, duration: '0:49' }, { trackNum: 57, duration: '1:00' }, { trackNum: 58, duration: '1:10' }, { trackNum: 59, duration: '1:26' }, { trackNum: 60, duration: '0:39' }, { trackNum: 61, duration: '0:48' }, { trackNum: 62, duration: '1:36' }, { trackNum: 63, duration: '1:39' }, { trackNum: 64, duration: '1:26' }, { trackNum: 65, duration: '1:05' }, { trackNum: 66, duration: '0:35' }, { trackNum: 67, duration: '3:34' }, { trackNum: 68, duration: '5:08' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Тема – эпиграф и главная партия', trackNum: 46, duration: '0:23', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 47, duration: '0:20', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 48, duration: '0:21', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия и повтор экспозиции', trackNum: 49, duration: '1:45', indentLevel: 2 },
            { type: 'subheading', section: 'Разработка', indentLevel: 1 },
            { type: 'track', section: 'Разработка', trackNum: 50, duration: '1:20', indentLevel: 2 },
            { type: 'track', section: 'Реприза: Главная партия и соло гобоя', trackNum: 51, duration: '0:53', indentLevel: 2 },
            { type: 'track', section: 'Побочная и заключительная партии', trackNum: 52, duration: '0:42', indentLevel: 2 },
            { type: 'subheading', section: 'Кода', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 53, duration: '1:27', indentLevel: 2 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'track', section: 'Первая тема вариаций', trackNum: 54, duration: '0:48', indentLevel: 1 },
            { type: 'track', section: 'Вторая тема вариаций', trackNum: 55, duration: '0:58', indentLevel: 1 },
            { type: 'track', section: 'Первая вариация на первую тему', trackNum: 56, duration: '0:49', indentLevel: 1 },
            { type: 'track', section: 'Первая вариация на вторую тему', trackNum: 57, duration: '1:00', indentLevel: 1 },
            { type: 'track', section: 'Вторая вариация на первую тему', trackNum: 58, duration: '1:10', indentLevel: 1 },
            { type: 'track', section: 'Вторая вариация на вторую тему', trackNum: 59, duration: '1:26', indentLevel: 1 },
            { type: 'track', section: 'Третья вариация на первую тему', trackNum: 60, duration: '0:39', indentLevel: 1 },
            { type: 'track', section: 'Четвертая вариация на первую тему', trackNum: 61, duration: '0:48', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 62, duration: '1:36', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть:' },
            { type: 'track', section: 'Первый раздел', trackNum: 63, duration: '1:39', indentLevel: 1 },
            { type: 'track', section: 'Трио', trackNum: 64, duration: '1:26', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 65, duration: '1:05', indentLevel: 1 },
            { type: 'track', section: 'Переход от скерцо к финалу', trackNum: 66, duration: '0:35', indentLevel: 1 },
            { type: 'subheading', section: 'IV часть:' },
            { type: 'track', section: 'Экспозиция и разработка', trackNum: 67, duration: '3:34', indentLevel: 1 },
            { type: 'track', section: 'Мотив – эпиграф в конце разработки финала, реприза и кода', trackNum: 68, duration: '5:08', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_5_DISK9 = [
    {
        num: 19,
        authorTitle: 'Л. ван Бетховен. Увертюра «Эгмонт»',
        performer: 'Лондонский симф. орк. Дир. А. Лиццио',
        tracks: [{ trackNum: 2, duration: '2:18' }, { trackNum: 3, duration: '0:51' }, { trackNum: 4, duration: '0:34' }, { trackNum: 5, duration: '0:42' }, { trackNum: 6, duration: '2:10' }, { trackNum: 7, duration: '1:21' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 2, duration: '2:18', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 3, duration: '0:51', indentLevel: 1 },
            { type: 'track', section: 'Побочная партия', trackNum: 4, duration: '0:34', indentLevel: 1 },
            { type: 'track', section: 'Разработка', trackNum: 5, duration: '0:42', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 6, duration: '2:10', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 7, duration: '1:21', indentLevel: 1 },
        ],
    },
    {
        num: 20,
        authorTitle: 'Ф. Шуберт. «Лесной царь»',
        performer: 'Д. Гнатюк',
        tracks: [{ trackNum: 9, duration: '4:27' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Лесной царь»', trackNum: 9, duration: '4:27', indentLevel: 0 },
        ],
    },
    {
        num: 21,
        authorTitle: 'Ф. Шуберт. Вечерняя серенада',
        performer: 'Д. Фишер-Дискау, И. Козловский',
        tracks: [{ trackNum: 11, duration: '3:52' }, { trackNum: 12, duration: '4:39' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'на немецком языке', trackNum: 11, duration: '3:52', indentLevel: 1 },
            { type: 'track', section: 'на русском языке', trackNum: 12, duration: '4:39', indentLevel: 1 },
        ],
    },
    {
        num: 22,
        authorTitle: 'Ф. Шуберт. Цикл «Прекрасная мельничиха»',
        performer: 'Э. Хаефлигер, С. Лемешев',
        tracks: [{ trackNum: 14, duration: '2:22' }, { trackNum: 15, duration: '2:08' }, { trackNum: 17, duration: '3:13' }, { trackNum: 19, duration: '6:06' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'В путь', indentLevel: 1 },
            { type: 'track', section: 'на немецком языке', trackNum: 14, duration: '2:22', indentLevel: 2 },
            { type: 'track', section: 'на русском языке', trackNum: 15, duration: '2:08', indentLevel: 2 },
            { type: 'subheading', section: 'Мельник и ручей', indentLevel: 1 },
            { type: 'track', section: 'Мельник и ручей', trackNum: 17, duration: '3:13', indentLevel: 2 },
            { type: 'subheading', section: 'Колыбельная ручья', indentLevel: 1 },
            { type: 'track', section: 'Колыбельная ручья', trackNum: 19, duration: '6:06', indentLevel: 2 },
        ],
    },
    {
        num: 23,
        authorTitle: 'Ф. Шуберт. Цикл «Зимний путь»',
        performer: 'Э. Хаефлигер, Д. Гнатюк',
        tracks: [{ trackNum: 21, duration: '5:02' }, { trackNum: 23, duration: '4:01' }, { trackNum: 25, duration: '3:58' }, { trackNum: 26, duration: '2:45' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'Спокойно спи', indentLevel: 1 },
            { type: 'track', section: 'Спокойно спи', trackNum: 21, duration: '5:02', indentLevel: 2 },
            { type: 'subheading', section: 'Весенний сон', indentLevel: 1 },
            { type: 'track', section: 'Весенний сон', trackNum: 23, duration: '4:01', indentLevel: 2 },
            { type: 'subheading', section: 'Шарманщик поет', indentLevel: 1 },
            { type: 'track', section: 'на немецком языке', trackNum: 25, duration: '3:58', indentLevel: 2 },
            { type: 'track', section: 'на русском языке', trackNum: 26, duration: '2:45', indentLevel: 2 },
        ],
    },
    {
        num: 24,
        authorTitle: 'Ф. Шуберт. Симфония №8 си минор',
        performer: 'Берлинский симф. орк. Дир. К.- А. Бюнте',
        tracks: [{ trackNum: 28, duration: '0:14' }, { trackNum: 29, duration: '0:50' }, { trackNum: 30, duration: '0:08' }, { trackNum: 31, duration: '0:37' }, { trackNum: 32, duration: '0:50' }, { trackNum: 33, duration: '0:28' }, { trackNum: 34, duration: '6:06' }, { trackNum: 35, duration: '3:04' }, { trackNum: 36, duration: '1:13' }, { trackNum: 37, duration: '2:16' }, { trackNum: 38, duration: '2:23' }, { trackNum: 39, duration: '2:09' }, { trackNum: 40, duration: '3:30' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:' },
            { type: 'track', section: 'Вступление', trackNum: 28, duration: '0:14', indentLevel: 1 },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 29, duration: '0:50', indentLevel: 2 },
            { type: 'track', section: 'Связующая партия', trackNum: 30, duration: '0:08', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 31, duration: '0:37', indentLevel: 2 },
            { type: 'track', section: 'Перелом в побочной партии', trackNum: 32, duration: '0:50', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 33, duration: '0:28', indentLevel: 2 },
            { type: 'subheading', section: 'Повтор экспозиции и разработка', indentLevel: 1 },
            { type: 'track', section: 'Повтор экспозиции и разработка', trackNum: 34, duration: '6:06', indentLevel: 1 },
            { type: 'subheading', section: 'Реприза', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 35, duration: '3:04', indentLevel: 1 },
            { type: 'subheading', section: 'Кода', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 36, duration: '1:13', indentLevel: 1 },
            { type: 'subheading', section: 'ІІ часть:' },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 37, duration: '2:16', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 38, duration: '2:23', indentLevel: 2 },
            { type: 'subheading', section: 'Реприза:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 39, duration: '2:09', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 40, duration: '3:30', indentLevel: 2 },
        ],
    },
];

const TABLE_CONTENT_5_DISK10 = [
    {
        num: 25,
        authorTitle: 'Ф. Шуберт. Экспромт Ми-бемоль мажор',
        performer: 'С. Капова (фортепиано)',
        tracks: [{ trackNum: 2, duration: '1:20' }, { trackNum: 3, duration: '1:29' }, { trackNum: 4, duration: '1:19' }, { trackNum: 5, duration: '0:28' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Первая часть', trackNum: 2, duration: '1:20', indentLevel: 1 },
            { type: 'track', section: 'Средняя часть', trackNum: 3, duration: '1:29', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 4, duration: '1:19', indentLevel: 1 },
            { type: 'track', section: 'Кода', trackNum: 5, duration: '0:28', indentLevel: 1 },
        ],
    },
    {
        num: 26,
        authorTitle: 'Ф. Шопен. Мазурка До мажор',
        performer: 'Е. Кисин (фортепиано)',
        tracks: [{ trackNum: 7, duration: '1:41' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Мазурка До мажор', trackNum: 7, duration: '1:41', indentLevel: 0 }],
    },
    {
        num: 27,
        authorTitle: 'Ф. Шопен. Мазурка ля минор',
        performer: 'Я. Олежничек (фортепиано)',
        tracks: [{ trackNum: 9, duration: '3:26' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Мазурка ля минор', trackNum: 9, duration: '3:26', indentLevel: 0 }],
    },
    {
        num: 28,
        authorTitle: 'Ф. Шопен. Вальс до-диез минор',
        performer: 'Т. Шебанова (фортепиано)',
        tracks: [{ trackNum: 11, duration: '3:45' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Вальс до-диез минор', trackNum: 11, duration: '3:45', indentLevel: 0 }],
    },
    {
        num: 29,
        authorTitle: 'Ф. Шопен. Ноктюрн фа минор',
        performer: 'С. Фалвей (фортепиано)',
        tracks: [{ trackNum: 13, duration: '4:02' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Ноктюрн фа минор', trackNum: 13, duration: '4:02', indentLevel: 0 }],
    },
    {
        num: 30,
        authorTitle: 'Ф. Шопен. Этюд до минор',
        performer: 'А. Скавронский (фортепиано)',
        tracks: [{ trackNum: 15, duration: '2:43' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Этюд до минор', trackNum: 15, duration: '2:43', indentLevel: 0 }],
    },
    {
        num: 31,
        authorTitle: 'Ф. Шопен. Этюд ми мажор',
        performer: 'А. Скавронский (фортепиано)',
        tracks: [{ trackNum: 17, duration: '4:58' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Этюд ми мажор', trackNum: 17, duration: '4:58', indentLevel: 0 }],
    },
    {
        num: 32,
        authorTitle: 'Р. Шуман. Фантастические пьесы. Порыв',
        performer: 'П. Егоров (фортепиано)',
        tracks: [{ trackNum: 19, duration: '3:14' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Порыв', trackNum: 19, duration: '3:14', indentLevel: 0 }],
    },
    {
        num: 33,
        authorTitle: 'Р. Шуман. Новеллетта №8 фа диез минор',
        performer: 'С. Рихтер (фортепиано)',
        tracks: [{ trackNum: 21, duration: '11:19' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Новеллетта №8 фа диез минор', trackNum: 21, duration: '11:19', indentLevel: 0 }],
    },
    {
        num: 34,
        authorTitle: 'Р. Вагнер. Опера «Тристан и Изольда». Вступление',
        performer: 'Байрейтский филарм. орк. Дир. Ю. Орманди',
        tracks: [{ trackNum: 23, duration: '10:37' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Опера «Тристан и Изольда». Вступление', trackNum: 23, duration: '10:37', indentLevel: 1 }],
    },
    {
        num: 35,
        authorTitle: 'К. Орф. Кантата «Carmina Burana». O Fortuna!',
        performer: 'Зальцбургский орк. и хор. Дир. К. Престел',
        tracks: [{ trackNum: 25, duration: '2:47' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Кантата «Carmina Burana». O Fortuna!', trackNum: 25, duration: '2:47', indentLevel: 1 }],
    },
    {
        num: 36,
        authorTitle: 'П. Хиндемит. Ludus Tonalis. Fuga Tertia in F. Andante',
        performer: 'С. Навасардьян (фортепиано)',
        tracks: [{ trackNum: 27, duration: '2:52' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Ludus Tonalis. Fuga Tertia in F. Andante', trackNum: 27, duration: '2:52', indentLevel: 1 }],
    },
    {
        num: 37,
        authorTitle: 'А. Берг. Опера «Воццек»',
        performer: 'Хор и орк. Венской филармонии. Дир. Христоф фон Дохнаньи',
        tracks: [{ trackNum: 29, duration: '4:45' }],
        rows: [{ type: 'title' }, { type: 'track', section: '3 акт. 1 картина. Покаяние Мари', trackNum: 29, duration: '4:45', indentLevel: 1 }],
    },
    {
        num: 38,
        authorTitle: 'Элла Фитцджеральд. Sophisticated Lady',
        performer: 'Элла Фитцджеральд',
        tracks: [{ trackNum: 31, duration: '3:38' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Sophisticated Lady', trackNum: 31, duration: '3:38', indentLevel: 0 }],
    },
    {
        num: 39,
        authorTitle: 'The Beatles. Yesterday',
        performer: 'The Beatles',
        tracks: [{ trackNum: 33, duration: '2:04' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'Yesterday', trackNum: 33, duration: '2:04', indentLevel: 0 }],
    },
    {
        num: 40,
        authorTitle: 'Э. Л. Уэббер. Иисус Христос-суперзвезда. I only want to say',
        performer: 'Лондон. орк. п/у А. Доггета',
        tracks: [{ trackNum: 35, duration: '5:34' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'I only want to say', trackNum: 35, duration: '5:34', indentLevel: 1 }],
    },
    {
        num: 41,
        authorTitle: 'Группа «Nirvana». «On a plain» из альбома Nevermind',
        performer: 'Группа «Nirvana»',
        tracks: [{ trackNum: 37, duration: '3:13' }],
        rows: [{ type: 'title' }, { type: 'track', section: '«On a plain» из альбома Nevermind', trackNum: 37, duration: '3:13', indentLevel: 1 }],
    },
];

const TABLE_CONTENT_5 = {
    1: TABLE_CONTENT_5_DISK1,
    2: TABLE_CONTENT_5_DISK2,
    3: TABLE_CONTENT_5_DISK3,
    4: TABLE_CONTENT_5_DISK4,
    5: TABLE_CONTENT_5_DISK5,
    6: TABLE_CONTENT_5_DISK6,
    7: TABLE_CONTENT_5_DISK7,
    8: TABLE_CONTENT_5_DISK8,
    9: TABLE_CONTENT_5_DISK9,
    10: TABLE_CONTENT_5_DISK10,
};

export { TABLE_CONTENT_5 };
